import React from 'react';
import { Avatar } from '@material-ui/core';
import { getImageUrl } from '../utils/Utils';

const ImageAvatar = (props) => {
  const { src } = props;

  return (
    <Avatar
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      src={getImageUrl(src)}
    />
  );
};

export default ImageAvatar;
